<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ gatehouse.name }}</h3>
                <div>
                    <button class="btn btn-sm btn-secondary me-3" @click="editGatehouse">
                        <icon icon="EditPen"></icon>
                    </button>
                    <button class="btn btn-sm btn-danger" @click="deleteGatehouse">
                        <icon icon="Trash"></icon>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <dl class="row mb-0">
                            <dt class="col-sm-4">{{ $t("gatehouse.name") }}</dt>
                            <dd class="col-sm-8">{{ gatehouse.name }}</dd>

                            <dt class="col-sm-4">{{ $t("gatehouse.address") }}</dt>
                            <dd class="col-sm-8">{{ gatehouse.address }}</dd>
                        </dl>
                    </div>
                    <div class="col-md-6">
                        <dl class="row mb-0">
                            <dt class="col-sm-4">{{ $t("gatehouse.qr") }}</dt>
                            <dd class="col-sm-8">
                                <img
                                    v-if="gatehouse.qr_img"
                                    :src="getQr"
                                    alt="QR kód"
                                    width="180"
                                />
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { CONFIG } from "@/config.js"
import Icon from '@/components/Icon.vue';

export default {
    components: {
        Icon,
    },
    data() {
        return {
            gatehouse: {},
        }
    },
    created() {
        this.getGatehouse();
    },
    methods: {
        getGatehouse() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/gatehouse`)
            .then(response => {
                this.gatehouse = response.data;
            })
            .catch(error => {
                console.error("Error loading gatehouse. ", error)
            });
        },
        editGatehouse() {
            this.$router.push({
                name: "GatehouseEditView",
                params: {
                    slug: this.$route.params.slug,
                    id: this.gatehouseId
                }
            });
        },
        deleteGatehouse() {
            const confirm = window.confirm(this.$t("utils.deleteConfirm", { name: this.gatehouse.name }));
            if (!confirm) return;

            this.$store.getters.api.delete(`/dashboard/${this.$route.params.slug}/gatehouse/${this.gatehouseId}/delete`)
            .then(() => {
                this.$store.commit("removeGatehouse", this.gatehouse.slug);

                const slug = this.$store.getters.gatehouses[0].slug;
                this.$router.push({
                    name: "GatehouseView",
                    params: {
                        slug: slug,
                    }
                });
            })
            .catch(error => {
                console.error("Error deleting gatehouse.", error);
            });
        },
    },
    computed: {
        getQr() {
            const slug = this.$route.params.slug;
            const url = CONFIG.api.baseUrl;
            return `${url}/dashboard/${slug}/gatehouse/qr-code-img`;
        },
        gatehouseId() {
            return this.gatehouse.id;
        }
    },
    watch: {
        "$route.params.slug": {
            immediate: true,
            handler(newSlug) {
                this.getGatehouse();
            }
        }
    }
}
</script>